import React from 'react';

const RankShield = ({ tier, size = 48 }) => {
  const height = size * 1.2;
  const gradId = `shield-${tier.name.toLowerCase()}`;
  const showText = size >= 40;
  return (
    <svg viewBox="0 0 100 120" width={size} height={height}
         style={{ filter: `drop-shadow(0 0 ${Math.max(3, size / 8)}px ${tier.color}60)`, display: 'block' }}>
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={tier.gradient[0]} />
          <stop offset="100%" stopColor={tier.gradient[1]} />
        </linearGradient>
      </defs>
      <path d="M10,2 L90,2 Q98,2 98,10 L98,65 Q98,85 50,118 Q2,85 2,65 L2,10 Q2,2 10,2 Z"
            fill={`url(#${gradId})`} stroke={tier.border} strokeWidth="2.5"/>
      <path d="M14,6 L86,6 Q94,6 94,14 L94,63 Q94,82 50,114 Q6,82 6,63 L6,14 Q6,6 14,6 Z"
            fill="rgba(255,255,255,0.08)"/>
      <line x1="18" y1="48" x2="82" y2="48" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
      <polygon points="50,14 53.5,24 63,24.5 55.5,31 58,41 50,35 42,41 44.5,31 37,24.5 46.5,24"
               fill="rgba(255,255,255,0.85)"/>
      {showText && (
        <text x="50" y="78" textAnchor="middle" fontFamily="Orbitron, Arial Black, sans-serif"
              fontSize={tier.name.length > 6 ? "10" : tier.name.length > 4 ? "12" : "14"}
              fontWeight="bold" fill="rgba(255,255,255,0.92)"
              letterSpacing="2">{tier.name.toUpperCase()}</text>
      )}
    </svg>
  );
};

export default RankShield;
